'use strict';

function FixedBottomButton() {
  this.id = null;
  this.node = null;

  this.init = function () {
    this.$window = $(window);
  };

  this.initAllReady = function () {
    this._unfixCta();
  };

  this._unfixCta = function () {
    var $signupCta = $(this.node).find('.js--fixed-cta');
    var signupCtaStay = 'fixed-cta--stay';

    this.$window.on('scroll', Throttle(function (event) {
      var windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
      var scrollTopDistance = $(window).scrollTop();

      if (scrollTopDistance + windowHeight > $('.marketing-footer').offset().top) {
        $signupCta.addClass(signupCtaStay);
      } else {
        $signupCta.removeClass(signupCtaStay);
      }
    }, 100) // if you set more than 100ms it might be visually noticible for the user
    );
  };
}